export default (style)=>{
  return(`

    .Row {
      overflow: hidden;
    }

    .Column {
      float: left;
    }

    .Column2 {
      width: 16.66%;
    }

    .Column10 {
      width: 83.33%;
    }
  `)
}
